import apiClient from '@/services/networking/apiClient';
import { ExportInvoicesParams } from '@/types/invoicing';

async function exportInvoices(params: ExportInvoicesParams): Promise<void> {
    await apiClient.v1.post('/accounting/export_invoices', {
        export_format: params.format,
        invoice_ids: params.invoicesIds,
    });
}

async function getInvoicePdfUrl(invoiceId: string): Promise<string> {
    const { data } = await apiClient.v1.get(
        `/accounting/${invoiceId}/download_internal_pdf`,
    );

    return data.payload.invoice_pdf_url;
}

export const InvoicingAPI = {
    exportInvoices,
    getInvoicePdfUrl,
};
